import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_story.less'
import TextBox from 'components/common/text_box'
import DropDown from 'components/common/dropdown'
import TipBox from 'components/common/tip_box'
import { getI18n } from 'client/i18n'
import {
  DESCRIPTION_ROWS,
  CROWDFUNDING_DESCRIPTION_LENGTH,
} from 'shared/lengths'
import { HeadingText } from '@paypalcorp/pp-react'

export const I18N_CONTEXT = 'components/pages/crowdfunding/pool_story'
const i18n = getI18n(I18N_CONTEXT)

class PoolDescription extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    shouldAutoFocus: PropTypes.bool,
    onChangeCover: PropTypes.func,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    categoryList: PropTypes.array,
  }

  state = {
    charCount: 0,
  }

  handleKeyUp = e => {
    const content = event.target.value.length
    this.setState({
      charCount: content,
    })
  }

  render() {
    const {
      fields: { category, description },
      handleSubmit,
      anyInactiveFieldsTouchedWithError,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <HeadingText size="md" styleName="title">
          {i18n('title')}
        </HeadingText>
        <div styleName="subtitle">{i18n('subtitle')}</div>
        <div>
          <div styleName="category">
            <DropDown
              label={i18n('category_title').props.children}
              dataNemo="pool-category"
              formField={category}
            >
              {this.props.categoryList.map(categoryOption => {
                return (
                  <option
                    key={categoryOption.key}
                    value={categoryOption.value}
                    styleName="fs-option"
                  >
                    {categoryOption.label}
                  </option>
                )
              })}
            </DropDown>
          </div>
          <div styleName="description-container">
            <div styleName="textbox-wrapper">
              <TextBox
                {...description}
                dataNemo="about-pool-description"
                multiline={true}
                rows={DESCRIPTION_ROWS}
                title={i18n('description_title')}
                onKeyUp={this.handleKeyUp}
                maxLength={CROWDFUNDING_DESCRIPTION_LENGTH}
              />
              <div styleName="char-count">
                {`${this.state.charCount}/${CROWDFUNDING_DESCRIPTION_LENGTH}`}
              </div>
            </div>
            <div styleName="tip-wrapper">
              <TipBox text={i18n('tip_description')} />
            </div>
          </div>
        </div>

        <button
          data-pa-click="next"
          className={`vx_btn vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          data-nemo="preview-next"
        >
          {i18n('next')}
        </button>
      </form>
    )
  }
}

export default cssModules(PoolDescription, styles)
